export default __webpack_public_path__ + "static/media/GR00017-talents_card_1.d0e47f82.svg";